import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/** The members who may be default approvers: those allowed to read incoming invoices. */
export function useIncomingInvoiceApproverCandidates() {
	/** Query */
	const query = useQuery({
		queryKey: ["incoming-invoice-default-approvers", "candidates"],
		queryFn: async () => {
			const response = await client.incoming_invoices["approver-candidates"].$get();
			const data = await responseHandler(response);
			return data.userIds;
		},
	});

	/** Return */
	return { ...query, candidateIds: new Set(query.data ?? []) };
}
